/// <reference types="./navigator.d.mts" />
import * as $iso639 from "../../../common/data/translate/language/iso639.mjs";
import { getLanguage as get_language } from "./navigator.ffi.ts";

export function language() {
  let _pipe = get_language();
  return $iso639.parse(_pipe);
}
